import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activityBeneficiariesInvoicesRoutes: MenuInterface[] = [
    {
        code: 'InvoicesList',
        route: [
            {
                content: '$type/invoices/list',
                focus: 'empty',
            }, 'content'
        ],
    },
];
